<template>
  <v-container id="openingbalance" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <base-material-card
          icon="mdi-card-text-outline"
          :title="
            id
              ? $i18n.t('Edit Opening Balance')
              : $i18n.t('Add Opening Balance')
          "
          class="px-3 py-1 small-icon"
        >
          <v-form id="form" v-model="isValid">
            <v-col>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding: 27px"
                  >
                    <v-row>
                      <v-col cols="12" sm="6" md="3" lg="3">
                        <z-client-select
                          :label="$i18n.t('Client')"
                          v-model="openingbal.client_id"
                          :rules="validationrules.client_id"
                          :disabled="isEdit"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3">
                        <z-entity-select
                          :corp="openingbal.client_id"
                          :label="$i18n.t('Client Entity')"
                          v-model="openingbal.clientEntity_id"
                          :disabled="isEdit"
                          autocomplete="off"
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="3" lg="2"
                        ><z-currency-select
                          :label="$i18n.t('Currency')"
                          v-model="openingbal.currency"
                          :rules="validationrules.currency"
                          :disabled="isEdit"
                          autocomplete="off"
                      /></v-col>

                      <v-col cols="12" sm="6" md="3" lg="2">
                        <v-text-field
                          :label="$i18n.t('Amount')"
                          type="number"
                          v-model="openingbal.balance"
                          :rules="validationrules.balance"
                          autocomplete="off"
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="3" lg="2">
                        <v-autocomplete
                          :label="$i18n.t('Year') + ' **'"
                          v-model="openingbal.year"
                          :rules="validationrules.year"
                          :disabled="isEdit"
                          item-text="name"
                          item-value="value"
                          :items="years"
                        />
                      </v-col>
                    </v-row>

                    <!-- <v-row>
                      <v-col cols="12">
                        <span style="font-size: 11px"
                          >** Select year as per financial year. Example :
                          2020-21 will be written as 2021</span
                        >
                      </v-col>
                    </v-row> -->

                    <v-row>
                      <v-simple-table dense style="width: 100%">
                        <template>
                          <thead class="thead">
                            <tr>
                              <th class="text-left">
                                {{ $i18n.t("Date") }}
                              </th>
                              <th class="text-left">
                                {{ $i18n.t("Amount") }}
                              </th>
                              <th class="text-left">
                                {{ $i18n.t("Settled") }}
                              </th>
                              <th class="text-left">
                                {{ $i18n.t("Mode") }}
                              </th>
                            </tr>
                          </thead>
                          <tbody class="tbody" v-if="openingbal.payments">
                            <tr
                              v-for="(payment, index) in openingbal.payments"
                              :key="index"
                              style="height: 50px"
                            >
                              <td>
                                <a
                                  :href="
                                    '/paymentreceived/' + payment.payment_id
                                  "
                                  >{{ payment.date }}</a
                                >
                              </td>
                              <td>
                                {{ payment.currency }} {{ payment.amount }}
                              </td>
                              <td>{{ payment.settled }}</td>
                              <td>{{ payment.mode }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-row>
                  </v-col>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="text-right my-5">
              <v-btn
                color="green"
                class="mr-0"
                v-on:click="saveOpeningBal()"
                :loading="loading"
                :disabled="!isValid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import auth from "@/store/user/module/auth";

@Component
export default class OpeningBalanceEdit extends Vue {
  isValid = true;
  isEdit = false;
  id = null;
  webcontent = {};
  openingbal = {
    client_id: null,
    clientEntity_id: null,
    currency: null,
    balance: null,
    year: null,
  };
  years = [{name : "2018-19", value : 2019}, {name : "2019-20", value : 2020}, {name : "2020-21", value : 2021}, {name : "2021-22", value : 2022}, {name : "2022-23", value : 2023}];

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onDialogChange(value) {
    this.showAddBill = value;
  }

  validationrules = {
    client_id: [(v) => !!v || this.$i18n.t("Select Client")],
    clientEntity_id: [(v) => !!v || this.$i18n.t("Select Client Entity")],
    currency: [(v) => !!v || this.$i18n.t("Select currency")],
    balance: [(v) => !!v || this.$i18n.t("Enter Balance")],
    year: [(v) => !!v || this.$i18n.t("Select year")],
  };

  async saveOpeningBal() {
    try {
      common.setLoading(true);
      const openingbal = await doPost(
        "/api/openingbalance/save",
        this.openingbal
      );
      if (!this.id) this.$router.push("/openingbalance/" + openingbal._id);
      this.id = openingbal._id;
      this.get();
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get() {
    try {
      const openingbal = await doGet(
        "/api/openingbalance/" + this.id + "/detail"
      );
      this.openingbal = openingbal;
      this.id = this.openingbal._id;
      this.isEdit = true;
    } catch (e) {
      common.setError(e.message);
    }
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  async mounted() {
    await auth.doPostLogin();

    this.webcontent = auth.authContent;
    this.openingbal.currency = this.webcontent.currencies[0];
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      await this.get(this.$route.params.id);
    }
  }
}
</script>
<style scoped>
.bill-left-headers {
  text-transform: none;
  top: 16px;
  left: 10px;
  font-size: 12px;
}
.bill-right-headers {
  text-transform: none;
  top: 20px;
  right: 0px;
  font-size: 12px;
}
.image-download {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: #42a5f5;
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.image-remove {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: red;
  top: 4px;
  right: -12px;
  font-size: 12px;
}
.table-border {
  border: 1px #dbdbdb solid;
  padding: 10px;
}
</style>
